import type { ReactNode } from "react";
import type { AuthSettings } from "@/auth/authConfig";
import { AuthSettingsContext } from "@/auth/authSettingsContext";

export function AuthSettingsProvider({
  settings,
  children,
}: {
  settings: AuthSettings;
  children: ReactNode;
}) {
  return <AuthSettingsContext.Provider value={settings}>{children}</AuthSettingsContext.Provider>;
}
